import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { API_URL, EntityName, Release, ReleaseDetails } from '@frontend-site/shared/data';
import { catchError, Observable, tap, throwError } from 'rxjs';
import { RdxContextType } from '../rdx/rdx-context-type.enum';
import { RdxFilterTypes } from '../rdx/rdx-filter-types.enum';
import { ReleaseStore } from './release.store';

@Injectable({ providedIn: 'root' })
export class ReleaseService {
    constructor(
        @Inject(API_URL) private readonly apiUrl: string,
        private readonly http: HttpClient,
        private readonly releaseStore: ReleaseStore
    ) {}

    loadReleases(companyId: number): Observable<Release[] | null> {
        this.releaseStore.setLoading(true);
        return this.getReleases(companyId).pipe(
            tap((releases) => {
                this.releaseStore.setReleases(releases);
                this.releaseStore.setLoading(false);
            }),
            catchError((err) => {
                this.releaseStore.setLoading(false);
                return throwError(() => new Error(err));
            })
        );
    }
    loadRelease(id: number, companyId: number): Observable<ReleaseDetails> {
        this.releaseStore.setLoading(true);
        return this.getRelease(id, companyId).pipe(
            tap((release) => {
                this.releaseStore.setCurrentRelease(release);
                this.releaseStore.setLoading(false);
            }),
            catchError((err) => {
                this.releaseStore.setLoading(false);
                return throwError(() => new Error(err));
            })
        );
    }

    getReleaseName(id: number, companyId: number): Observable<EntityName> {
        const params = new HttpParams({
            fromObject: {
                contextType: RdxContextType.RELEASE,
                type: RdxContextType.RELEASE,
                companyId: companyId,
                contextId: id
            }
        });

        return this.http
            .get<EntityName>(`${this.apiUrl}/rdx/entity/${id}/name`, { params })
            .pipe(tap((res) => this.releaseStore.setCurrentReleaseName(res?.name)));
    }

    private getReleases(companyId: number): Observable<Release[]> {
        return this.http.get<Release[]>(`${this.apiUrl}/rdx/getFilterData`, {
            params: {
                filterType: RdxFilterTypes.RELEASE,
                entityType: RdxContextType.PORTFOLIO,
                contextType: RdxContextType.PORTFOLIO,
                companyId: companyId,
                contextId: companyId
            }
        });
    }
    private getRelease(id: number, companyId: number): Observable<ReleaseDetails> {
        const params = new HttpParams().set('companyId', companyId).set('contextId', id).set('contextType', RdxContextType.RELEASE);
        return this.http.get<ReleaseDetails>(`${this.apiUrl}/rdx/release/${id}`, { params });
    }
}
